import React, { useRef } from "react";
import PropTypes from "prop-types";
import { Row, Col, Collapse, Well } from "react-bootstrap";
import Formsy from "formsy-react";

import CallTypeSelect from "../../common/CallTypeSelect";
import CustomerSelect from "../../common/CustomerSelect";
import DepartmentSelect from "../../common/DepartmentSelect";
import UserSelect from "../../common/UserSelect";
import ProjectStatusSelect from "../../common/ProjectStatusSelect";
import ProjectCategorySelect from "../../common/ProjectCategorySelect";
import ProjectFavoritesSelect from "../../common/ProjectFavoritesSelect";
import DepartmentCategoryMultiSelect from "../../common/DepartmentCategoryMultiSelect";

const ProjectListFilters = ({
  show,
  filters,
  handleChange,
  handleToggle,
  handleSearchChange,
  loading,
  checked,
  favorites,
  handleReset
}) => {
  const ref = useRef();

  return (
    <Collapse in={show} className="filter-container">
      <div>
        <Well>
          <Formsy className="vertical form">
            <div className="fields">
              <div className="form-group row">
                <input
                  ref={ref}
                  style={{ height: 38 }}
                  placeholder="Search..."
                  className="form-control"
                  type="search"
                  name="search"
                  defaultValue={filters.search}
                  onChange={({ target: { value } }) => {
                    handleSearchChange(value);
                  }}
                />
              </div>

              <div className="form-group row">
                <ProjectStatusSelect
                  disabled={loading}
                  isMulti
                  value={filters.project_status}
                  onChange={handleChange("project_status")}
                />
              </div>

              <div className="form-group row">
                <CallTypeSelect
                  disabled={loading}
                  placeholder="Call Type"
                  value={filters.call_type}
                  isMulti
                  onChange={handleChange("call_type")}
                />
              </div>

              <div className="form-group row">
                <CustomerSelect
                  disabled={loading}
                  isMulti
                  value={filters.customer}
                  onChange={handleChange("customer")}
                />
              </div>
              <div className="form-group row">
                <DepartmentSelect
                  disabled={loading}
                  value={filters.department}
                  isMulti
                  onChange={handleChange("department")}
                />
              </div>
              <div className="form-group row">
                <DepartmentCategoryMultiSelect
                  disabled={!filters?.department?.length || loading}
                  value={filters?.department_category}
                  department={filters?.department}
                  name="department_category"
                  onChange={handleChange("department_category")}
                />
              </div>
              <div className="form-group row">
                <ProjectCategorySelect
                  disabled={loading}
                  isMulti
                  value={filters.category}
                  onChange={handleChange("category")}
                />
              </div>
              <div className="form-group row">
                <UserSelect
                  disabled={loading}
                  isMulti
                  value={filters.project_manager}
                  placeholder="Project Manager"
                  onChange={handleChange("project_manager")}
                />
              </div>
              <Row className="mb-0">
                <Col md={12}>
                  <button
                    disabled={loading}
                    className="btn btn-warning"
                    type="button"
                    onClick={() => {
                      ref.current.value = "";
                      handleReset();
                    }}
                  >
                    Reset
                  </button>
                </Col>
              </Row>

              <ProjectFavoritesSelect
                disabled={loading}
                isMulti
                favorites={favorites}
                value={checked}
                onChange={handleToggle}
              />
            </div>
          </Formsy>
        </Well>
      </div>
    </Collapse>
  );
};

ProjectListFilters.propTypes = {
  show: PropTypes.bool,
  handleChange: PropTypes.func,
  handleSearchChange: PropTypes.func,
  handleReset: PropTypes.func,
  loading: PropTypes.bool,
  filters: PropTypes.object,
  handleToggle: PropTypes.func,
  checked: PropTypes.bool,
  favorites: PropTypes.array
};

export default ProjectListFilters;
